<template>
    <div class="jieguo">
        <van-nav-bar
                title="支付结果"
                style="border-bottom: #e0e0e0 solid 1px"
        />
        <div class="jg-notice">
            <div class="jg-msg">
                <div class="jg-msg__icon-area">
                    <i class="el-icon-success" style="color: #11b95c;font-size:100px">
                    </i>
                </div>
                <div class="jg-msg__text-area">
                    <h2 class="jg-msg__title">支付成功</h2>
                    <p class="jg_msg__desc">您可能需要进行下列操作</p>
                </div>
                <div>
                    <van-button type="default" style="height: 40px;width: 160px" @click="toMyOrder">我的订单</van-button>
                    <van-button type="default" style="height: 40px;width: 160px;margin-left:30px" @click="toHome">返回首页
                    </van-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getDeptId, getDeptName} from "../../utils/auth";

    export default {
        name: 'home',
        components: {},
        data() {
            return {
                deptId: '',
                type: '',
            }
        },
        created() {
            document.title = getDeptName()
            this.deptId = getDeptId()
            this.type = this.$route.params.type
        },
        methods: {
            toMyOrder() {
                if (this.type == 0) {
                    this.$router.push('/ztOrder/' + this.deptId + '/1')
                } else {
                    this.$router.push('/myOrder/' + this.deptId + '/1')
                }
            },
            toHome() {
                this.$router.push('/home/' + this.deptId)
            },
        },
    }
</script>

<style>
    .jieguo {

    }

    .jg-notice {
        margin: auto;
        font-size: 18px;
        text-align: center;
        margin-top: 16%;
    }

    .jg-msg {
        padding-top: 36px;
        text-align: center;
    }

    .jg-msg__icon-area {
        margin-bottom: 18px;
    }

    .jg-msg__text-area {
        margin-bottom: 18px;
        padding: 0 20px;
    }

    .jg-msg__title {
        margin-bottom: 5px;
        font-weight: 400;
        font-size: 18px;
    }

    .jg_msg__desc {
        margin-top: 8px;
        font-size: 15px;
        color: #888888;
    }
</style>
